import { Mail, Phone, MapPin, Globe } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_b5b811b2-a7ff-452a-9cfa-2f673fde2f06/artifacts/5t2w93oo_Simple%20Solutions.png";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top, behavior: "smooth" });
  }
};

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-black text-white pt-20 pb-8 relative overflow-hidden"
    >
      <div className="absolute -top-32 left-1/4 w-[420px] h-[420px] rounded-full bg-[#BF1828]/15 blur-[120px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex flex-col leading-none">
              <span className="font-display font-bold text-base tracking-tight">
                SIMPLE SOLUTIONS
              </span>
              <span className="font-display text-[10px] tracking-[0.35em] text-[#BF1828] mt-1">
                ASESORES
              </span>
            </div>
            <p className="mt-6 font-body text-sm leading-relaxed text-[#BFBFBF] max-w-sm">
              Donde la creatividad y la estrategia se encuentran para dar vida
              a campañas que impactan, inspiran y convierten.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#BF1828] font-medium mb-5">
              Navegación
            </div>
            <ul className="space-y-3 font-body text-sm text-white/85">
              {[
                ["nosotros", "Nosotros"],
                ["valores", "Valores"],
                ["servicios", "Servicios"],
                ["contacto", "Contacto"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button
                    onClick={() => scrollTo(id)}
                    data-testid={`footer-link-${id}`}
                    className="hover:text-[#BF1828] transition-colors"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#BF1828] font-medium mb-5">
              Contacto
            </div>
            <ul className="space-y-4 font-body text-sm text-white/85">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#BF1828] mt-0.5 shrink-0" />
                <span className="leading-relaxed">
                  Calle Jorge Santayana 4963, int. Z, C.P. col. Jardines
                  Universidad, C.P. 45110, Zapopan, Jalisco.
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#BF1828] mt-0.5 shrink-0" />
                <a
                  href="tel:+523310685211"
                  className="hover:text-[#BF1828] transition-colors"
                >
                  33 1 068 5211
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#BF1828] mt-0.5 shrink-0" />
                <a
                  href="mailto:contacto@simplesolutionsasesores.com"
                  className="hover:text-[#BF1828] transition-colors break-all"
                >
                  contacto@simplesolutionsasesores.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Globe size={16} className="text-[#BF1828] mt-0.5 shrink-0" />
                <span>simplesolutionsasesores.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-white/55">
            © {new Date().getFullYear()} Simple Solutions Asesores. Todos los derechos reservados.
          </p>
          <p className="text-[11px] uppercase tracking-[0.25em] text-white/55">
            Publicidad · Diseño · Marketing
          </p>
        </div>
      </div>
    </footer>
  );
};
